module.exports = __webpack_public_path__ + "static/media/logo-junina.4ba0a9f3.png";